import React, { useState, useEffect } from 'react';

const Navbar = ({ route, scrollToSection, navigateToPath, goToHomeSection }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleHomeSectionClick = (sectionId) => {
        if (isMobileView) {
            setIsMobileMenuOpen(false);
        }
        if (route === 'home') {
            scrollToSection(sectionId);
            return;
        }
        goToHomeSection(sectionId);
    };

    const handlePathClick = (path) => {
        if (isMobileView) {
            setIsMobileMenuOpen(false);
        }
        navigateToPath(path);
    };

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobileView(mobile);
            if (!mobile) {
                setIsMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <nav className="navbar">
            <a
                href="/"
                onClick={(e) => {
                    e.preventDefault();
                    handlePathClick('/');
                }}
                className="navbar-brand"
            >
                <span>Mixout Technologies</span>
            </a>

            <button
                className={`hamburger-menu ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
                aria-expanded={isMobileMenuOpen}
            >
                <span className={'hamburger-lines'}></span>
                <span className={'hamburger-lines'}></span>
                <span></span>
            </button>

            <div className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
                <a href="/" onClick={(e) => { e.preventDefault(); handlePathClick('/'); }}>Home</a>
                <a href="/#product" onClick={(e) => { e.preventDefault(); handleHomeSectionClick('product'); }}>Products</a>
                <a href="/#about" onClick={(e) => { e.preventDefault(); handleHomeSectionClick('about'); }}>The Studio</a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); handleHomeSectionClick('contact'); }}>Contact</a>
            </div>
        </nav>
    );
};

export default Navbar;
